// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
// utils
import { Roles } from '../../constants/roles.enum';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: 22, height: 22 }}
  />
);

const ICONS = {
  map: getIcon('ic_map'),
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  home: getIcon('ic_home'),
  person: getIcon('ic_person'),
  settings: getIcon('ic_settings'),
  mail: getIcon('ic_mail'),
  page: getIcon('ic_page'),
  user: getIcon('ic_user'),
  faceSearch: getIcon('person_search'),
  copy: getIcon('ic_copy'),
  error: getIcon('ic_error'),
  charts: getIcon('ic_charts'),
  editor: getIcon('ic_editor'),
  upload: getIcon('ic_upload'),
  animate: getIcon('ic_animate'),
  calendar: getIcon('ic_calendar'),
  elements: getIcon('ic_elements'),
  carousel: getIcon('ic_carousel'),
  language: getIcon('ic_language'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  components: getIcon('ic_components'),
  authenticator: getIcon('ic_authenticator'),
  employee: getIcon('ic_employee'),
  zone: getIcon('zone'),
  fire: getIcon('fire_truck')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'sidemenu.subheader.dashboard',
    items: [
      // {
      //   role: [Roles.USER, Roles.CLIENT_ADMIN],
      //   title: 'sidemenu.subheader.dashboard.home',
      //   href: PATH_DASHBOARD.general.home,
      //   icon: ICONS.home,
      //   feature: 'base'
      // },
      // {
      //   role: [Roles.USER, Roles.CLIENT_ADMIN],
      //   title: 'sidemenu.subheader.dashboard.locations',
      //   href: PATH_DASHBOARD.general.locations,
      //   icon: ICONS.map,
      //   feature: 'base'
      // },
      // {
      //   role: [Roles.USER, Roles.CLIENT_ADMIN],
      //   title: 'sidemenu.subheader.dashboard.employees',
      //   href: PATH_DASHBOARD.general.addEmployee,
      //   icon: ICONS.employee,
      //   feature: 'employee_base'
      // },
      // {
      //   role: [Roles.USER, Roles.CLIENT_ADMIN],
      //   title: 'sidemenu.subheader.dashboard.zones',
      //   href: PATH_DASHBOARD.general.addZone,
      //   icon: ICONS.zone,
      //   feature: 'zone_base'
      // },

      {
        role: [Roles.ADMIN, Roles.SUPERADMIN],
        title: 'sidemenu.subheader.dashboard.companies',
        href: PATH_DASHBOARD.general.companies,
        icon: ICONS.components
      },
      {
        role: [Roles.FIRE_FIGHTER],
        title: 'sidemenu.subheader.dashboard.fire.fighter',
        href: PATH_DASHBOARD.general.fireFighter,
        icon: ICONS.fire
      },
      {
        role: [Roles.SUPERVISOR],
        title: 'sidemenu.subheader.dashboard.supervisor',
        href: PATH_DASHBOARD.general.supervisor,
        icon: ICONS.components
      },
      {
        role: [Roles.FIRE_FIGHTER],
        title: 'sidemenu.subheader.dashboard.companies',
        href: PATH_DASHBOARD.general.companiesFireFighter,
        icon: ICONS.components
      }

    ]
  },
  {
    subheader: 'sidemenu.subheader.profile.security',
    items: [
      {
        role: [Roles.USER, Roles.CLIENT_ADMIN],
        title: 'sidemenu.subheader.dashboard.alarm.and.warning',
        href: PATH_DASHBOARD.general.alarm,
        icon: ICONS.animate,
        feature: 'base'
      },
      {
        role: [Roles.SUPERVISOR],
        title: 'sidemenu.subheader.dashboard.alarm.and.warning',
        href: PATH_DASHBOARD.general.alarmSupervisor,
        icon: ICONS.animate
      },
      {
        role: [Roles.USER, Roles.CLIENT_ADMIN],
        title: 'sidemenu.subheader.dashboard.face.search',
        href: PATH_DASHBOARD.general.faceSearch,
        icon: ICONS.faceSearch,
        feature: 'face_search'
      },
    ]
  },
  {
    subheader: 'sidemenu.subheader.profile.retail',
    items: [
      {
        role: [Roles.USER],
        title: 'sidemenu.subheader.dashboard.entity.count',
        href: PATH_DASHBOARD.general.entityCount,
        icon: ICONS.person,
        feature: 'entity_count'
      }
    ]
  },
  {
    subheader: 'sidemenu.subheader.profile.quality',
    items: [
      {
        role: [Roles.USER],
        title: 'sidemenu.subheader.dashboard.entity.count',
        href: PATH_DASHBOARD.general.entityCount,
        icon: ICONS.person,
        feature: 'entity_count_quality'
      }
    ]
  },

  {
    subheader: 'sidemenu.subheader.profile.productivity',
    items: [
      {
        role: [Roles.USER, Roles.CLIENT_ADMIN],
        title: 'sidemenu.subheader.dashboard.employee.productivity.detail',
        href: PATH_DASHBOARD.general.employeeProductivityDetail,
        icon: ICONS.analytics,
        feature: 'employee_productivity'
      },
      {
        role: [Roles.USER, Roles.CLIENT_ADMIN],
        title: 'sidemenu.subheader.dashboard.zone.productivity.detail',
        href: PATH_DASHBOARD.general.zoneProductivityDetail,
        icon: ICONS.analytics,
        feature: 'zone_productivity'
      }
    ]
  },

  // PROFILE AND SETTINGS
  // ----------------------------------------------------------------------
  {
    subheader: 'sidemenu.subheader.profile.management',
    items: [
      {
        role: [Roles.USER],
        title: 'sidemenu.subheader.dashboard.performance.of.connection',
        href: PATH_DASHBOARD.general.connectivity,
        icon: ICONS.charts,
        feature: 'base'
      },
      {
        role: [Roles.USER, Roles.CLIENT_ADMIN, Roles.ADMIN, Roles.SUPERADMIN],
        title: 'sidemenu.subheader.profile.settings',
        href: PATH_DASHBOARD.general.settings,
        icon: ICONS.settings
      },
    ]
  }
];

export default sidebarConfig;
